// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_54-6";
export var headerCell = "_54-2";
export var rowWrapper = "_54-4";
export var stickyAggregationCell = "_54-a";
export var stickyAggregationRow = "_54-7";
export var stickyColumnCell = "_54-9";
export var stickyColumnHeaderCell = "_54-8";
export var table = "_54-1";
export var virtualRowWrapper = "_54-5";
export var virtualTableContainer = "_54-0";
export var white = "_54-3";